<template>
  <form-card
    :labelText="$t('api.soa_receipt.apply_doc.label')"
  >
    <el-table
      :data="applyDoc"
    >
      <std-opt
        :isForm="false"
        name="documentType"
        data="type"
        :labelText="$t('api.soa_receipt.apply_doc.fields.type.label')"
        :hasFilter="false"
      >
      </std-opt>
      <text-field
        :isForm="false"
        base="soa_receipt"
        :labelText="$t('api.soa_receipt.apply_doc.fields.number.label')"
        name="number"
        :width="150"
      >
      </text-field>
      <time-field
        :isForm="false"
        base="soa_receipt"
        name="date"
        :labelText="$t('api.soa_receipt.apply_doc.fields.date.label')"
        dataType="date"
      >
      </time-field>
      <text-field
        :isForm="false"
        base="soa_receipt"
        name="amount"
        :isNumber="true"
        align="right"
        :width="90"
      >
      </text-field>
      <text-field
        :isForm="false"
        base="soa_receipt"
        name="vat_amount"
        :isNumber="true"
        align="right"
        :width="110"
      >
      </text-field>
      <text-field
        :isForm="false"
        base="soa_receipt"
        name="total_amount"
        :isNumber="true"
        align="right"
        :width="110"
      >
      </text-field>
    </el-table>
  </form-card>
</template>

<script>
import { getLabelText, getOptName } from '@/utils/i18n'

export default {
  name: 'apply-doc-table',
  data () {
    return {
    }
  },
  props: {
    base: {
      type: String,
      required: true
    },
    applyDoc: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
  },
  methods: {
    getLabelText,
    getOptName
  }
}
</script>
